export default __webpack_public_path__ + "static/media/sr-next.09d86787.png";